import React, { useEffect, useId, useRef } from "react";

/** Natywny modal zatrzymuje fokus i umożliwia anulowanie klawiszem Escape. */
export default function IssueConfirmationDialog({
  order,
  onConfirm,
  onCancel,
}) {
  const dialogRef = useRef(null);
  const cancelRef = useRef(null);
  const titleId = useId();
  const descriptionId = useId();
  useEffect(() => {
    const dialog = dialogRef.current;
    dialog.showModal();
    cancelRef.current.focus();
    return () => dialog.close();
  }, []);
  return (
    <dialog
      ref={dialogRef}
      className="premium-issue-dialog"
      aria-labelledby={titleId}
      aria-describedby={descriptionId}
      onCancel={(event) => {
        event.preventDefault();
        onCancel();
      }}
    >
      <h2 id={titleId}>Wystawić świadectwo?</h2>
      <p id={descriptionId}>
        Potwierdzasz poprawność aktualnego podglądu PDF i zlecasz wystawienie
        świadectwa. Dokument otrzyma numer i podpis, a jego dane nie będą już
        edytowalne.
      </p>
      <dl className="premium-issue-summary">
        <dt>Eksporter</dt>
        <dd style={{ whiteSpace: "pre-line" }}>{order.config.exporter}</dd>
        <dt>Faktura</dt>
        <dd>{order.draft.invoiceNumbers || "Nie podano"}</dd>
        <dt>Odbiorca</dt>
        <dd>{order.draft.recipient.name || "Nie podano"}</dd>
      </dl>
      <div className="premium-form-actions">
        <button
          ref={cancelRef}
          type="button"
          className="btn btn-outline-primary"
          onClick={onCancel}
        >
          Anuluj
        </button>
        <button type="button" className="btn btn-primary" onClick={onConfirm}>
          Tak, wystaw świadectwo
        </button>
      </div>
    </dialog>
  );
}
